export const palette = {
  black: "#1d1d1d",
  white: "#ffffff",
  green: "green",
  offWhite: "#e6e6e6",
  lighterOrange: "#F8E7D9",
  lightOrange: "#D06400",
  orange: "#EAA945",
  orangeDarker: "#EB9918",
  darkBlue: "#0B1336",
  darkGrey: "#666666",
  grey: "#DADADA",
  lightGrey: "#F5F5F5",
  lighterGrey: "#E5E5E5",
  lightestGrey: "#F7F7FA",
  mediumGrey: "#CCCCCC",
  lightBlue: "#6b9fe4",
  lighterBlue: "#E6F0FA",
  lightestBlue: "#F7F7FA",
  lightGreen: "#27AE60",
  lighterGreen: "#F4F9F6",
  angry: "#dd3333",
  lightRed: "#E51937",
  lighterRed: "#FBDDE1",
  red: "#D81620",
  inputNavigation: "#007AFF",
  purple: "#7B61FF"
};
